"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const FarmTable_vue_1 = __importDefault(require("./components/FarmTable.vue"));
const FieldsTable_vue_1 = __importDefault(require("./components/FieldsTable.vue"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const FarmListController_1 = __importDefault(require("./modules/controllers/FarmListController"));
const MapZone_1 = __importDefault(require("../Map/models/MapZone"));
const Utils_1 = require("../Map/Utils");
const ViewZero_vue_1 = __importDefault(require("../Profile/Access/components/ViewZero.vue"));
const Loader_vue_1 = __importDefault(require("./components/Loader.vue"));
const FarmSelectorModal_vue_1 = __importDefault(require("./components/FarmSelectorModal.vue"));
const PreQuoteModal_vue_1 = __importDefault(require("./components/PreQuoteModal.vue"));
const floating_vue_1 = require("floating-vue");
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const proj_1 = require("ol/proj");
const GeometryCollection_1 = __importDefault(require("ol/geom/GeometryCollection"));
let ClientFarmListView = class ClientFarmListView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAP_ID = 'preview-map-container';
        this.MAP_CONTROLLER = new Controller_1.default();
        this.CONTROLLER = FarmListController_1.default.getInstance();
        this.editQuote = false;
        this.proposalQuote = -1;
        this.loaderSearch = false;
        this.farmSelectorModal = false;
        this.preQuoteModal = false;
        this.forWholeFarm = false;
        this.textFilter = '';
        this.farmsFilters = [];
        this.fieldsForQuote = [];
        this.fieldsFiltered = [];
        this.fields_wkt = [];
        /*  async drawFieldInMap() {
             this.CONTROLLER.selectedFarms.forEach((field: Farm) => {
                 this.MAP_CONTROLLER.zoneBuilder.drawZone(
                     new MapZone({
                         geoData: field.geodata,
                         fillColor: field.crop ? `${field.crop?.color}50` : '#eebb5460',
                         strokeColor: field.crop ? field.crop?.color : '#eebb54',
                         enableHoverInteraction: true,
                         enableSelectInteraction: true,
                         zoneName: `${field.id}-${field.fieldName}`,
                         centerZone: false,
                         avg: 0,
                         markers: [],
                         preciseResult: false,
                         modifyInteraction: true
                     }),
                     700,
                     [50, 50, 50, 50],
                 );
             })
    
             const polygonsWkt = this.fields_wkt.map(parseWKT);
             const combinedGeometry = new GeometryCollection(polygonsWkt);
             const extent = transformExtent(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
             await center(this.MAP_CONTROLLER.map, extent, 700, [50, 50, 50, 50]);
         } */
    }
    get oldPrice() {
        return '$1,450';
    }
    get newPrice() {
        return '$2,450';
    }
    get allFarms() {
        return this.CONTROLLER.farms;
    }
    get allCustomQuotableFarms() {
        return this.CONTROLLER.customQuotableFarms;
    }
    get currentPage() {
        return this.CONTROLLER.currentPage;
    }
    get currentFarms() {
        return (this.farmsFilters.length > 0 || this.textFilter) ?
            this.farmsFilters :
            this.CONTROLLER.farmsCurrentPage;
    }
    get currentFarm() {
        return this.CONTROLLER.activeFarm;
    }
    get fieldsForThisFarm() {
        return this.CONTROLLER.activeFarm.fields;
    }
    get cropsQuoted() {
        const uniqueCrops = this.fieldsForQuote.reduce((acc, item) => {
            const exists = acc.some((crop) => crop.name === item.crop.name);
            if (!exists) {
                acc.push(item.crop);
            }
            return acc;
        }, []);
        return uniqueCrops;
    }
    get acreageQuoted() {
        var _a, _b;
        const totalAcreage = this.fieldsForQuote.reduce((sum, item) => sum + item.acreage.value, 0);
        return new Acreage_1.default(totalAcreage, (_b = (_a = this.fieldsForQuote[0]) === null || _a === void 0 ? void 0 : _a.acreage) === null || _b === void 0 ? void 0 : _b.unit);
    }
    get fieldsOverThreshold() {
        const ac = this.acreageQuoted;
        const unit = ac.unit;
        if (unit.toLowerCase().startsWith('h')) {
            (ac.value > this.CONTROLLER.HA_THRESHOLD) ? true : false;
        }
        if (unit.toLowerCase().startsWith('a')) {
            (ac.value > this.CONTROLLER.AC_THRESHOLD) ? true : false;
        }
        return false;
    }
    updateFieldsForQuote(p) {
        this.fieldsForQuote = this.fieldsForThisFarm.filter((g) => p.includes(g.id));
    }
    isQuoteEdition() {
        const currentURLString = new URL(window.location.href).searchParams;
        const action = currentURLString.get('action') || null;
        const proposalId = currentURLString.get('proposal') || null;
        if (action !== null && action === 'editQuote' && proposalId !== null) {
            this.editQuote = true;
            this.proposalQuote = parseInt(proposalId);
        }
    }
    triggerRequestQuote() {
        // console.log('triggered')
    }
    async loadPage(page) {
        var _a;
        this.textFilter = '';
        this.farmsFilters = [];
        const pageM = page;
        if (this.CONTROLLER.farmsPages.some(entry => entry.page === pageM)) {
            this.CONTROLLER.farmsCurrentPage = ((_a = this.CONTROLLER.farmsPages.find((farmPage) => { return farmPage.page === pageM; })) === null || _a === void 0 ? void 0 : _a.farms) || [];
            this.CONTROLLER.currentPage = pageM;
            this.drawFarmInMap(this.CONTROLLER.farmsCurrentPage[0]);
        }
        else {
            await this.CONTROLLER.changeFarmListPage(pageM);
            this.drawFarmInMap(this.CONTROLLER.farmsCurrentPage[0]);
        }
    }
    get farmsPage() {
        var _a;
        return (_a = this.CONTROLLER.farmsPages.find((farmPage) => { return farmPage.page === this.CONTROLLER.currentPage; })) === null || _a === void 0 ? void 0 : _a.farms;
    }
    changeFarm(f) {
        this.dismissFarmSelectorModal();
        this.CONTROLLER.setActiveFarm(f);
        this.fieldsForQuote = [];
        this.drawFarmInMap(this.CONTROLLER.activeFarm);
    }
    back() {
        window.history.back();
        //window.location.href = '/'
    }
    quoteWholeFarm() {
        this.forWholeFarm = true;
        this.deployPreQuoteModal();
    }
    quotePartialFarm() {
        this.forWholeFarm = false;
        this.deployPreQuoteModal();
    }
    editCurrentQuote() {
        this.deployPreQuoteModal();
    }
    get myThreshold() {
        const ac = this.acreageQuoted;
        const unit = ac.unit;
        if (unit.toLowerCase().startsWith('h')) {
            return new Acreage_1.default(this.CONTROLLER.HA_THRESHOLD, unit).shortLabel;
        }
        if (unit.toLowerCase().startsWith('a')) {
            return new Acreage_1.default(this.CONTROLLER.AC_THRESHOLD, unit).shortLabel;
        }
        return '';
    }
    deployFarmSelectorModal() {
        this.farmSelectorModal = true;
    }
    dismissFarmSelectorModal() {
        this.farmSelectorModal = false;
    }
    deployPreQuoteModal() {
        this.preQuoteModal = true;
    }
    dismissPreQuoteModal() {
        this.preQuoteModal = false;
    }
    async mounted() {
        this.MAP_CONTROLLER.create(this.MAP_ID, this.map_config.provider, this.map_config.apikey, '', '', '');
        await this.CONTROLLER.changeFarmListPage(1);
        this.CONTROLLER.setInitialFarm();
        this.drawFarmInMap(this.CONTROLLER.activeFarm);
        this.isQuoteEdition();
    }
    /*     onSearchChange(f: string) {
            this.loaderSearch = true;
            this.textFilter = f;
            if (f.length > 0) {
                this.farmsFilters = this.CONTROLLER.farms
                    .filter((farm: Farm) => farm.name.toUpperCase().trim().includes(f.toUpperCase().trim())).map((sam) => sam);
                if (this.farmsFilters[0]) {
                    this.drawFarmInMap(this.farmsFilters[0]);
                }
            } else {
                this.textFilter = null;
                this.farmsFilters = this.CONTROLLER.farms;
                this.drawFarmInMap(this.CONTROLLER.farmsCurrentPage[0])
            }
    
            this.loaderSearch = false;
    
        } */
    get farms() {
        return this.CONTROLLER.farms;
    }
    get mapInstance() {
        return this.MAP_CONTROLLER.map;
    }
    async drawFarmInMap(farm) {
        if (this.farms.length > 0) {
            const layer = (0, Utils_1.findLayerById)('zone-layer', this.mapInstance);
            const centerPadding = [100, 100, 100, 100];
            const centerAnimationDuration = 700;
            if (layer) {
                const source = layer.getSource();
                source.clear();
            }
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: farm.geodata,
                fillColor: '#eebb5460',
                strokeColor: '#eebb54',
                enableHoverInteraction: false,
                enableSelectInteraction: false,
                zoneName: `${farm.id}-${farm.name}`,
                centerZone: true,
                avg: 0,
                markers: [],
                preciseResult: false,
                modifyInteraction: false
            }), centerAnimationDuration, centerPadding);
            this.fields_wkt.push(farm.geodata);
            const polygonsWkt = this.fields_wkt.map(Utils_1.parseWKT);
            const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
            const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
            await (0, CenterUtility_1.center)(this.MAP_CONTROLLER.map, extent, 700, [50, 50, 50, 50]);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClientFarmListView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClientFarmListView.prototype, "dataSet", void 0);
ClientFarmListView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, MapAttributions: bmk_ui_framework_1.MapAttributions, Search: bmk_ui_framework_1.Search, Plus: lucide_vue_next_1.Plus, Minus: lucide_vue_next_1.Minus, FarmTable: FarmTable_vue_1.default, FieldsTable: FieldsTable_vue_1.default, Pagination: bmk_ui_framework_1.Pagination, ViewZero: ViewZero_vue_1.default, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon, Loader: Loader_vue_1.default, FarmSelectorModal: FarmSelectorModal_vue_1.default, PreQuoteModal: PreQuoteModal_vue_1.default, CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon, ArrowLeft: lucide_vue_next_1.ArrowLeft, Dropdown: floating_vue_1.Dropdown, Info: lucide_vue_next_1.Info }
    })
], ClientFarmListView);
exports.default = ClientFarmListView;
